<template>
  <div>
    <b-modal
      id="confirmationModal"
      :title="foritem ? foritem.type.title : ''"
      ok-title="بازگشت"
      ok-only
    >
      <ConfirmationDetails
        v-bind:foritem="foritem"
        v-bind:afterverified="afterverified"
      ></ConfirmationDetails>
    </b-modal>
    <b-card>
      <div v-if="!loaded" class="row">
        <div class="col-md-4 col-sm-4">
          <div class="mt-3"><b-skeleton height="57.56px"></b-skeleton></div>
        </div>
        <div class="col-md-4 col-sm-4">
          <div class="mt-3"><b-skeleton height="57.56px"></b-skeleton></div>
        </div>
        <div class="col-md-4 col-sm-4">
          <div class="mt-3"><b-skeleton height="57.56px"></b-skeleton></div>
        </div>
        <div class="col-md-4 col-sm-4">
          <div class="mt-3"><b-skeleton height="57.56px"></b-skeleton></div>
        </div>
        <div class="col-md-4 col-sm-4">
          <div class="mt-3"><b-skeleton height="57.56px"></b-skeleton></div>
        </div>
        <div class="col-md-4 col-sm-4">
          <div class="mt-3"><b-skeleton height="57.56px"></b-skeleton></div>
        </div>
      </div>
      <div v-if="loaded" class="row">
        <div
          class="col-md-4 col-sm-4"
          v-for="item of userConf"
          v-bind:key="item.id"
        >
          <b-button
            class="mt-3"
            block
            @click="ConfFor(item)"
            :variant="getBGstatus(item)"
            text-variant="light"
          >
            <div>{{ item.type.title }}</div>
            <div>{{ item.status.title }}</div>
          </b-button>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import persianDate from "../../helpers/persianDate";
import httpHelper from "../../helpers/httpHelper";
import ConfirmationDetails from "./ConfirmationDetails";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
export default {
  name: "userConf",
  data: function () {
    return {
      userConf: [],
      foritem: null,
      loaded: false,
    };
  },
  components: {
    ConfirmationDetails,
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "تایید اطلاعات کاربری" }]);
    this.LoadUserConf();
    // this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
    //   this.LoadUserConf();
    // });
  },
  methods: {
    afterverified() {
      this.$bvModal.hide("confirmationModal");
      this.LoadUserConf();
    },
    LoadUserConf() {
      this.loaded = false;
      httpHelper.setAuth();
      httpHelper
        .getData("userconf")
        .then((res) => {
          this.userConf = res.result;
          this.loaded = true;
        })
        .finally(() => {});
    },
    ConfFor(item) {
      if (item.status.id == 1520) {
        this.foritem = item;
        this.$bvModal.show("confirmationModal");
      }
    },
    getBGstatus(item) {
      if (item.mdid7_status == 1520) {
        return "danger";
      } else if (item.mdid7_status == 1521) {
        return "warning";
      }
      return "success";
    },
  },
};
</script>
